import { ReactNode } from 'react';

import { SearchToolbar } from 'components/Search/SearchToolbar';
import { Layout } from 'layouts/Layout';
import { CmsApiPage } from 'modules/cms/api/types/CmsApiPage';
import { getContentLocaleUrl, getHideFooterDivider } from 'modules/cms/helpers';
import {
  useCmsApiPageDefaultSearchType,
  useCmsApiPageHasPostSearchToolbar,
} from 'modules/cms/hooks';
import { isDefined } from 'utils/functional';

type Props = {
  content: CmsApiPage;
  children: ReactNode;
};

export function CmsLayout({ content, children }: Props) {
  const defaultSearchType = useCmsApiPageDefaultSearchType({
    cmsApiPage: content,
  });
  const hasPostSearchToolbar = useCmsApiPageHasPostSearchToolbar({
    cmsApiPage: content,
  });

  const hero =
    content.heroSearch && content.heroSearch.onlyResults
      ? undefined
      : content.heroSearch;

  const hideFooterDivider = getHideFooterDivider({ content });
  const localeUrl = getContentLocaleUrl({ content });

  return (
    <Layout
      content={content}
      hero={hero}
      defaultWithSearchHero={isDefined(content.heroSearch)}
      showListingCounts={
        !!content.heroSearch && !!content.heroSearch.showCounts
      }
      navSection="MAIN"
      searchMode={false}
      postSearchToolbar={
        hasPostSearchToolbar ? <SearchToolbar content={content} /> : undefined
      }
      defaultSearchType={defaultSearchType}
      hideFooterDivider={hideFooterDivider}
      localeUrl={localeUrl}
    >
      {children}
    </Layout>
  );
}
